export default __webpack_public_path__ + "static/media/misc-books3-1440w.54ab03d4.avif";